const baseUrl = "./billing";

export const getCurrentBill = (businessPartner) => baseUrl + "/current-bill?businessPartner=" + businessPartner;

export const payBill = (customerId, amount) => baseUrl + "/payBill?amount=" + amount + "&cutomerId=" + customerId;
export const setPaperBill = (customerId, setPaperFlag) => baseUrl + "/setPaperBill?customerId=" + customerId + "&setPaperFlag=" + setPaperFlag;
export const getInvoiceByContractAccountId = () => baseUrl + "/billing/invoiceDetailsSet";
export const getQuickBill = () => baseUrl + "/billing/quickbillsummary";
export const downloadPdfFile = (invoiceNo) => baseUrl + "/billing/invoiceattachment";
export const printBill = (invoiceNo) => baseUrl + "/printBill?invoiceNo=" + invoiceNo;
export const getPaymentHistory = () => baseUrl + "/billing/paymentHistory";
export const getToken = baseUrl + "/encryption-token";
export const getPaymentProcessStatus = () => baseUrl + "/payment-process";
export const fetchCountryCodesUrl = `${baseUrl}/fetchcountrycodes`;
